import styled from "styled-components";
import { Modal } from "reactstrap";

import "bootstrap/dist/css/bootstrap.min.css";

export const StyledModal = styled(Modal)<typeof Modal>``;
